import { useSyncExternalStore } from "react"
import { closeDialogById, getOpenDialogsSnapshot, subscribeToOpenDialogs } from "@/shared/lib/dialog/model/dialog-store"

export function DialogContainer() {
  const openDialogs = useSyncExternalStore(subscribeToOpenDialogs, getOpenDialogsSnapshot)

  if (openDialogs.length === 0) {
    return null
  }

  return openDialogs.map((dialog) => {
    const DialogComponent = dialog.component

    return (
      <DialogComponent
        key={dialog.id}
        {...dialog.props}
        persistent={dialog.persistent}
        isOpen={dialog.isOpen}
        onOpenChange={(open) => {
          if (!open) {
            closeDialogById(dialog.id)
          }
        }}
        close={() => closeDialogById(dialog.id)}
      />
    )
  })
}
